__turbopack_context__.v({
  "dot": "khdAKW_dot",
  "light": "khdAKW_light",
  "white": "khdAKW_white",
});
